export default (() => {
  const element = document.getElementById('page-not-loading');
  if (!element) {
    return;
  }
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  element.parentNode.removeChild(element);
});